export const DELIVERY_TYPE_TRANSLATION = {
  'Despacho a domicilio': 'Envío a domicilio',
  'Retiro en Tienda': 'Retiro en Tienda',
  'Retiro en punto': 'Pinflag Click and Collect'
}

export const TAX_DOCUMENT_TYPES = {
  receipt: 'Boleta',
  invoice: 'Factura'
}

export const BILLING_KEY_TRANSLATION = {
  corporateName: 'Razón social',
  category: 'Giro',
  corporateRut: 'Rut',
  corporatePhone: 'Teléfono',
  address: 'Dirección',
  district: 'Comuna'
}
